export default __webpack_public_path__ + "static/media/duplicate.4c19a6dd.svg";